import { useEffect, useState } from "react";

import { UserAvatar } from "@/components";
import { useAmityAuth } from "@/providers/context";

import { getAvatar } from "../../util";

// If a user is provided, use their avatar and display name
// Otherwise, use the authenticated user's avatar and display name
export const CommunityUserAvatar = ({
  user,
  size = "m",
}: {
  user?: Amity.User;
  size?: "s" | "m";
}) => {
  const { authState } = useAmityAuth();

  const [avatar, setAvatar] = useState<string>(user?.avatar?.fileUrl ?? "");

  const displayName = user
    ? user.displayName
    : authState?.authenticatedUser?.displayName;

  const avatarFileId = user
    ? user.avatarFileId
    : authState?.authenticatedUser?.avatarFileId;

  useEffect(() => {
    if (avatarFileId && !avatar) {
      getAvatar(avatarFileId).then((avatar) => {
        setAvatar(avatar);
      });
    }
  }, [avatarFileId, avatar]);

  return (
    <UserAvatar
      className={
        size === "s"
          ? "h-[36px] w-[36px] text-[14px]"
          : "h-[48px] w-[48px] text-[20px]"
      }
      name={displayName ?? ""}
      imageUrl={avatar}
    />
  );
};
